export default __webpack_public_path__ + "static/media/logo-primary-better-white.8de1871c.svg";